import React, { useEffect } from 'react'
import { Button, Card, Form, Input, message, Row, Space } from 'antd'
import NapiLogo from '../images/napi_logo_horizontal.svg'
import '../css/auth.css'
import { useNavigate, useSearchParams } from 'react-router-dom'

const ResetarSenha = () => {
    const [searchParams] = useSearchParams()
    const emailParam = searchParams.get('email')

    const [form] = Form.useForm()
    const navigate = useNavigate()

    useEffect(() => {
        if (emailParam) {
            form.setFieldValue('email', emailParam)
        }
    }, [emailParam, form])

    const onFinish = () => {
        fetch('/api/auth/resetarSenha', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form.getFieldsValue(true)),
        })
            .then((res) => {
                if (res.status === 200) {
                    message.success('Senha alterada com sucesso!')
                    navigate('/login')
                } else if (res.status === 401) {
                    message.error(
                        <>
                            Erro ao tentar alterar a senha.
                            <br />
                            Verifique se o email e PIN estão corretos
                            <br />e se a solicitação ainda está dentro do prazo
                            de 15 minutos.
                        </>,
                        8
                    )
                } else {
                    message.error('Erro ao alterar senha')
                }
            })
            .catch(() =>
                message.error(
                    'Erro ao contactar o servidor, tente novamente mais tarde'
                )
            )
    }

    return (
        <div className="auth-bg">
            <div className="auth-container">
                <Space
                    direction="vertical"
                    size="large"
                    style={{ width: '100%' }}
                >
                    <Row align="middle" justify="center">
                        <img
                            src={NapiLogo}
                            alt="Logo do NAPI Solar"
                            width={300}
                            style={{ display: 'block' }}
                        />
                    </Row>

                    <Row align="middle" justify="center">
                        <Card className="auth-card">
                            <Form
                                form={form}
                                name="resetar_senha"
                                onFinish={onFinish}
                            >
                                <Form.Item
                                    name="email"
                                    rules={[
                                        {
                                            required: true,
                                            type: 'email',
                                            message:
                                                'Por favor entre um email válido',
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder="Email"
                                        size="large"
                                        maxLength={50}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="pinTrocaSenha"
                                    rules={[
                                        {
                                            required: true,
                                            pattern: /^[0-9]{6}$/,
                                            message:
                                                'Digite o PIN de 6 dígitos enviado por email',
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder="PIN (6 dígitos)"
                                        size="large"
                                        maxLength={6}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="novaSenha"
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'A senha deve ter 8-16 caracteres com pelo menos 1 letra e 1 número',
                                            pattern:
                                                /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/,
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        placeholder="Nova senha"
                                        maxLength={16}
                                        size="large"
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="confirmarNovaSenha"
                                    hasFeedback
                                    dependencies={['novaSenha']}
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'Por favor confirme sua senha',
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (
                                                    !value ||
                                                    getFieldValue(
                                                        'novaSenha'
                                                    ) === value
                                                ) {
                                                    return Promise.resolve()
                                                }
                                                return Promise.reject(
                                                    new Error(
                                                        'As duas senhas inseridas não são iguais'
                                                    )
                                                )
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password
                                        placeholder="Confirme sua nova senha"
                                        maxLength={16}
                                        size="large"
                                    />
                                </Form.Item>

                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    block
                                    size="large"
                                >
                                    Alterar senha
                                </Button>
                            </Form>
                        </Card>
                    </Row>
                </Space>
            </div>
        </div>
    )
}

export default ResetarSenha
